module.exports = __webpack_public_path__ + "img/app-store.2757f354.svg";